'use client'

import { ReactNode, useContext, useState } from "react";
import { NavContext } from "@/context/navContext";
import SectionTitle from "@/components/etc/section_title";
import { useTranslations } from "next-intl";

export default function SectionTab(
    { setshowSpots, setshowScore, showSpots, showScore, setpositionTop  }: 
    { 
        setshowSpots?: React.Dispatch<React.SetStateAction<boolean>>;
        setshowScore?: React.Dispatch<React.SetStateAction<boolean>>;
        showSpots?:boolean,
        showScore?:boolean,
        // setpositionTop?: React.Dispatch<React.SetStateAction<boolean>>;
        setpositionTop?: (value: boolean) => void;
    }
) {
    const { movePage } = useContext(NavContext)
    const t = useTranslations('PageTitle')

    return (
        <div className={`flex center iframeStickyTab`} style={{borderBottom:"1px solid var(--border"}}>
            <div className={`flex`} 
                onClick={()=>{
                    setpositionTop?.(true);
                    
                    setTimeout(() => {
                        setshowSpots?.(true); 
                        setshowScore?.(false);
                    }, 0);
                }}>
                <SectionTitle type="sports" className={`customTitle flex_end ${showSpots ? "active" :""}`}>
                    <span>{t('스포츠 정보')}</span>
                </SectionTitle>
            </div>
            <div className={`flex`} 
                onClick={()=>{
                    setpositionTop?.(true);
                    setTimeout(() => {
                        setshowSpots?.(false); 
                        setshowScore?.(true);
                    }, 0);
                }}>
                <SectionTitle type="livescore" className={`customTitle start flex ${showScore ? "active" :""}`}>
                    <span>{t('스포츠 스코어')}</span>
                </SectionTitle>
            </div>
        </div>
    )
}